export const GET_USER_ACCESS_INFO = 'GET_USER_ACCESS_INFO';
export const SET_USER_ACCESS_INFO = 'SET_USER_ACCESS_INFO';
export const SET_OKTA_AUTHENTICATED_STATUS = 'SET_OKTA_AUTHENTICATED_STATUS';
